import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProjectProvider } from "@/context/ProjectContext";
import Layout from "@/components/layout/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import Calculator from "@/pages/Calculator";
import EPDs from "@/pages/EPDs";
import Monthly from "@/pages/Monthly";
import CarbonCost from "@/pages/CarbonCost";
import Forecast from "@/pages/Forecast";
import Optimizer from "@/pages/Optimizer";
import Procurement from "@/pages/Procurement";
import Impact from "@/pages/Impact";
import Compliance from "@/pages/Compliance";
import Billing from "@/pages/Billing";
import Organization from "@/pages/Organization";
import Capture from "@/pages/Capture";
import Risk from "@/pages/Risk";
import Geographic from "@/pages/Geographic";
import Schedule from "@/pages/Schedule";
import Help from "@/pages/Help";
import Security from "@/pages/Security";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0F1115] text-ink-dim text-sm">
        Initialising CarbonIQ…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicGuestOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ProjectProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="top-right" />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route
                path="/login"
                element={
                  <PublicGuestOnly>
                    <Login />
                  </PublicGuestOnly>
                }
              />
              <Route
                path="/register"
                element={
                  <PublicGuestOnly>
                    <Register />
                  </PublicGuestOnly>
                }
              />
              <Route
                element={
                  <Protected>
                    <Layout />
                  </Protected>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/calculator" element={<Calculator />} />
                <Route path="/epds" element={<EPDs />} />
                <Route path="/monthly" element={<Monthly />} />
                <Route path="/cost" element={<CarbonCost />} />
                <Route path="/forecast" element={<Forecast />} />
                <Route path="/optimizer" element={<Optimizer />} />
                <Route path="/procurement" element={<Procurement />} />
                <Route path="/impact" element={<Impact />} />
                <Route path="/compliance" element={<Compliance />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="/organization" element={<Organization />} />
                <Route path="/capture" element={<Capture />} />
                <Route path="/risk" element={<Risk />} />
                <Route path="/geographic" element={<Geographic />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/help" element={<Help />} />
                <Route path="/security" element={<Security />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ProjectProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
